import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { IOptionsResponse } from '../../../common/common.types'
import { setAgeOptions } from '../store/options.actions'

export function* getAgeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getAgeOptions,
    ])
    const { entity } = response
    yield put(setAgeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getAgeOptions() error: ${e}`))
  }
}

export function* getAgeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getAgeOptions)
}
